import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SupaAuthProvider } from "@/context/SupaAuthContext";
import { Toaster } from "sonner";
import Shell from "@/components/Shell";
import B2BShell from "@/components/B2BShell";
import RequireSubscription from "@/components/RequireSubscription";
import RequireB2BAuth from "@/components/RequireB2BAuth";
import Home from "@/pages/Home";
import Settings from "@/pages/Settings";
import MileagePage from "@/pages/MileagePage";
import Landing from "@/pages/Landing";
import LandingV2 from "@/pages/LandingV2";
import LandingV3 from "@/pages/LandingV3";
import Redeem from "@/pages/Redeem";
import Login from "@/pages/Login";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Subscribe from "@/pages/Subscribe";
import HopeAir from "@/pages/HopeAir";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import BillingSuccess from "@/pages/BillingSuccess";
import Onboard from "@/pages/Onboard";
import B2BLogin from "@/pages/b2b/B2BLogin";
import AdminFirms from "@/pages/b2b/AdminFirms";
import AdminFirmDetail from "@/pages/b2b/AdminFirmDetail";
import FirmDashboard from "@/pages/b2b/FirmDashboard";
import FirmBatchDetail from "@/pages/b2b/FirmBatchDetail";
import InstallHint from "@/components/InstallHint";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/v2" element={<LandingV2 />} />
      <Route path="/v3" element={<LandingV3 />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/redeem" element={<Redeem />} />
      <Route path="/hope-air" element={<HopeAir />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/billing/success" element={<BillingSuccess />} />
      <Route path="/onboard" element={<Onboard />} />
      <Route element={<RequireSubscription><Shell /></RequireSubscription>}>
        <Route path="/log" element={<Home />} />
        <Route path="/mileage" element={<MileagePage />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      {/* B2B — separate Supabase-Auth surface */}
      <Route path="/b2b/login" element={<B2BLogin />} />
      <Route element={<RequireB2BAuth><B2BShell /></RequireB2BAuth>}>
        <Route path="/admin" element={<AdminFirms />} />
        <Route path="/admin/firms/:firmId" element={<AdminFirmDetail />} />
        <Route path="/firm" element={<FirmDashboard />} />
        <Route path="/firm/batches/:batchId" element={<FirmBatchDetail />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <SupaAuthProvider>
        <BrowserRouter>
          <AppRouter />
          <InstallHint />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </SupaAuthProvider>
    </AuthProvider>
  );
}

export default App;
